import request from '@service/request';
import config from '@config';
import { getAuthOptions } from '@service/utils.js';

const path = `${config.apiURL}/scores`;

export const fetchScoresByUser = (token, id) =>
  request.get(`${path}/${id}`, getAuthOptions(token));
